// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m915vq{overflow-y:hidden}\n._1e0c11p5{display:grid}\n._1reo15vq{overflow-x:hidden}\n._2z051n2s{grid-template-rows:minmax(0,1fr) max-content}\n._yv0e1osq{grid-template-columns:100%}", ""]);
// Exports
module.exports = exports;
